import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'cardTitle'
	| 'buildButtonLabel'
	| 'buildingButtonLabel'
	| 'buildAutomationErrorTitle'
	| 'buildAutomationErrorDescription'
	| 'expandCardLabel'
	| 'collapseCardLabel';

const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.card-title',
		defaultMessage: 'Automation flow',
		description: 'Title for the automation flow creation card',
	},
	buildButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.build-button-label',
		defaultMessage: 'Build automation',
		description: 'Label for the build automation button',
	},
	buildingButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.building-button-label',
		defaultMessage: 'Building...',
		description: 'Label for the build button while building',
	},
	buildAutomationErrorTitle: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.build-automation-error-title',
		defaultMessage: 'Failed to create automation',
		description: 'Error title when automation creation fails',
	},
	buildAutomationErrorDescription: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.build-automation-error-description',
		defaultMessage: 'Something went wrong while creating the automation. Please try again.',
		description: 'Error description when automation creation fails',
	},
	expandCardLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.expand-card-label',
		defaultMessage: 'Expand card',
		description: 'Accessible label for expand card button',
	},
	collapseCardLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.collapse-card-label',
		defaultMessage: 'Collapse card',
		description: 'Accessible label for collapse card button',
	},
});

export default messages;
